import React from 'react'
import { Typography } from '@mui/material';
const Unauthorize = () => {
  return (
    <div className="container " style={{ margin: '0px', padding: '0px' }}>
 
    <div class="left-panel">
    </div>
    <div className="right-panel">

          <div style={{paddingTop:'15%'}}>
          <Typography variant="h6" gutterBottom>
            You are not authorized to access this application
          </Typography>
          </div>  
          </div>
  </div>
  )
}

export default Unauthorize